<template>
  <div class="img-wrapper">
    <img src="@/assets/img/jinjuenglish/jinjuenglish.png" usemap="#image-map" />

    <map name="image-map">
      <area
        target="_blank"
        alt=""
        title=""
        href="https://lifeedu.carrotapply.com/home?idxLeSiteMain=4"
        coords="855,511,1545,740"
        shape="rect"
      />
      <area
        target="_blank"
        alt=""
        title=""
        href="https://pp7lz.channel.io/support-bots/58449"
        coords="618,825,1163,943"
        shape="rect"
      />
      <area
        target="_blank"
        alt=""
        title=""
        href="https://lifeedu.carrotapply.com/learningSupport/noticeDetail?idxNotice=6&amp;idxLeSiteMain=4"
        coords="1227,823,1784,948"
        shape="rect"
      />
    </map>
  </div>
</template>

<script>
import ImageMap from "image-map";
export default {
  mounted() {
    ImageMap("img[usemap]");
  },
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  max-width: 800px;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }
}
</style>
